export default __webpack_public_path__ + "static/discount-bg-27bee66c17db7747331d7b11a150c821.png";